/** tempexp_14728-full-file */
import React, { FC } from 'react';

import { SharedItemProps } from '../../DataListItemRow.types';
import { Checkbox } from '../Checkbox/Checkbox';
import { Date } from '../Date/Date';
import { Download } from '../Download/Download';
import { Expires } from '../Expires/Expires';
import { ItemName } from '../ItemName/ItemName';
import { Pic } from '../Pic/Pic';
import { Publish } from '../Publish/Publish';
import { Size } from '../Size/Size';
import { TableColumn } from '../TableColumn/TableColumn';

interface SharedProps extends SharedItemProps {
    checkboxClassname?: string;
}

export const Shared: FC<SharedProps> = (props) => {
    return (
        <>
            <TableColumn>
                <Checkbox className={props.checkboxClassname} onCheckboxClick={props.onCheckboxClick} isSelected={props.isSelected} />
                <Pic
                    isFolder={props.isFolder}
                    thumbUrl={props.thumbUrl}
                    kind={props.kind}
                    isVirus={!!props.isVirus}
                    ext={props.ext || ''}
                    isAutoDelete={props?.isAutoDelete}
                    publicExpires={props.publicExpires}
                />
            </TableColumn>
            <TableColumn width="100%" overflow="hidden">
                <ItemName name={props.name} ext={props.ext || ''} />
            </TableColumn>
            {props.isFolder && Boolean(props.publicExpires) && (
                <TableColumn flexBasis={140} flexShrink={0} justifyContent="flex-end">
                    <Expires expires={props.publicExpires} isAutoDelete={props.isAutoDelete} isShared />
                </TableColumn>
            )}
            {!props.isFolder && (
                <TableColumn flexBasis={140} flexShrink={0} justifyContent="flex-end">
                    <Date date={props.mtime} />
                </TableColumn>
            )}
            <TableColumn flexBasis={132} flexShrink={0} justifyContent="center">
                <Size size={props.size} />
            </TableColumn>
            <TableColumn flexBasis={128} flexShrink={0} justifyContent="flex-end" gap={20}>
                <Publish onClick={props.onPublish} isShared={props.isPublic} />
                <Download
                    onClick={props.onDownload}
                    ext={props.isFolder ? 'zip' : props.ext}
                    size={props.size}
                    id={props.id}
                    storage={props.storage}
                />
            </TableColumn>
        </>
    );
};
